import axios from 'axios';

export const request = ({url, method, payload = {}, headers = {}}) => {
  const HTTP = axios.create({
    headers: {
      'Content-Type': 'application/json'
    }
  });

  const requestConfig = {
    url,
    method,
    data: payload,
    headers
  };

  return HTTP.request(requestConfig);
}

export const get = ({url, headers = {}}) => {
  return request({url, payload: {}, headers, method: 'get'})
}

export const post = ({url, payload = {}, headers = {}}) => {
  return request({url, payload, headers, method: 'post'})
}

export const put = ({url, payload = {}, headers = {}}) => {
  return request({url, payload, headers, method: 'put'})
}

export const del = ({url, payload = {}, headers = {}}) => {
  return request({url, payload, headers, method: 'delete'})
}

export const url = endpoint => {
  return `/api/${endpoint}`
}

export const auth = rootState => {
  if(!rootState.auth.affiliate){
    return {}
  }

  return {
    ['auth-token']: rootState.auth.affiliate.token
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/services/Backend/HttpRequest.js